import { Alert, Box, Fade, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Blog from '../components/Blog';
import { BlogModel } from '../model/Blog.model';
import { LibraryBooks } from '@mui/icons-material';
import LoadingBlog from '../components/LoadingBlog';
import PageHeader from '../components/PageHeader';
import { BLOG_API_BASE } from '../config/site';

const Blogs: React.FC = () => {
  const [blogs, setBlogs] = useState<BlogModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`${BLOG_API_BASE}/getBlogs`)
      .then((res) => {
        if (!res.ok) throw new Error(`getBlogs responded ${res.status}`);
        return res.json();
      })
      .then((json: BlogModel[]) => {
        if (cancelled) return;
        // The API already sorts newest-first; sort defensively so an older
        // deployment can't reintroduce arbitrary Scan ordering.
        setBlogs([...json].sort((a, b) => b.created - a.created));
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setFailed(true);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  let body: React.ReactNode;
  if (loading) {
    body = [0, 1, 2].map((i) => <LoadingBlog key={i} />);
  } else if (failed) {
    body = <Alert severity="error">Couldn't load posts right now. Please try again later.</Alert>;
  } else {
    // Rows mount only once the fetch resolves, so a plain `in` Fade animates
    // from that moment. The async load is what triggers the transition rather
    // than defeating it. The per-row delay staggers them into view.
    body = blogs.map((blog, i) => (
      <Fade in timeout={600} style={{ transitionDelay: `${i * 90}ms` }} key={blog.id}>
        <Box>
          <Blog
            id={blog.id}
            name={blog.name}
            headline={blog.headline}
            topics={blog.topics}
            created={blog.created}
            location={blog.location}
            image={blog.image}
          />
        </Box>
      </Fade>
    ));
  }

  return (
    <Box>
      <PageHeader icon={<LibraryBooks fontSize="large" />} title="Blogs and Writing">
        You may find beauty within these pages.
        You may find mental stimulation, or controversy.
        Most of all, you will see who I truly am.  Beware,
        especially if you are trying to hire me.  There will be hot takes.
        There will be politics.  It all comes from a desire to
        see the world as it is and refuse.
      </PageHeader>
      <Stack spacing={2}>{body}</Stack>
    </Box>
  );
};

export default Blogs;
